import { z } from "zod";

export const agentReferenceSchema = z
    .object({
        id: z.string().min(1).max(256),
    })
    .strict();

export type SerializedAgentReference = z.infer<typeof agentReferenceSchema>;
